import React from "react";
import {
  Home,
  ClipboardList,
  CalendarCheck2,
  UserCircle2,
} from "lucide-react";
import SharedDashboardLayout from "../layout/shared-dashboard-layout";

const sidebarLinks = [
  { title: "Dashboard", icon: Home, href: "/customer/dashboard" },
  { title: "My Requests", icon: ClipboardList, href: "/customer/jobs" },
  { title: "Schedule", icon: CalendarCheck2, href: "/customer/schedule" },
];

const Layout = () => {
  return (
    <SharedDashboardLayout 
      sidebarLinks={sidebarLinks}
      defaultRole="customer"
    />
  );
};

export default Layout;
